import {IApiModel} from './api-model.interface';
import {LevelType, SelectedLevel} from './level-type.model';
import {ACCESS} from './access.model';
import {BaseGroup} from './group-base.model';

export interface TreeGroupOptionItem {
    title: string;
    subcategories: TreeOptionItem[];
}

export interface TreeOptionItem {
    id: any;
    title: string;
    type: LevelType;
    subcategories: TreeItem[];
}

export class TreeItem implements TreeOptionItem {
    id: number;
    level: number;
    parent: number;
    title: string;
    order: number;
    subcategories: TreeItem[] = [];
    type: LevelType;
    role: any;
    currency: string;
    isOwner: boolean;

    constructor(init?: Partial<TreeItem>) {
        Object.assign(this, init);
    }
}
